import { Alert, AlertColor, Snackbar } from "@mui/material";

interface Props {
  alert: { text: string; severity: AlertColor };
  setAlert: (
    alert: {
      text: string;
      severity: AlertColor;
    } | null,
  ) => void;
  duration?: number;
}

const TimedAlert = ({ alert, setAlert, duration = 3000 }: Props) => {
  return (
    <Snackbar
      open={!!alert}
      autoHideDuration={duration}
      onClose={() => setAlert(null)}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert severity={alert.severity} variant="filled">
        {alert.text}
      </Alert>
    </Snackbar>
  );
};

export default TimedAlert;
